import * as React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Store } from "redux";
import Router from "@linkfluence/core/router";
import { Product } from "@linkfluence/models/product";
import LfReset from "../../glossy/components/lf-reset";
import history from "./history";

interface IProps {
  store: Store<any>;
  client: Product;
  children: React.ReactNode;
  loader: React.ReactNode;
  refresher?: (location: any, nextLocation: any) => boolean;
}

const Component = ({ store, client, refresher, loader, children }: IProps) => {
  return (
    <Provider store={store}>
      <LfReset />
      <ConnectedRouter history={history}>
        <Router client={client} refresher={refresher} loader={loader}>
          {children}
        </Router>
      </ConnectedRouter>
    </Provider>
  );
};

export default Component;
